import { createContext, useContext } from 'react';
import PrintProperties from '../PrintProperties';

const printProperties = new PrintProperties();
export const AdvantageCycleInfoContext = createContext({
	printProperties: printProperties,
	data: null,
	combos: {},
	loading: true,
	filters: {},
	onPhasesFilter: {},
	isXmlProcess: false,
	ciResultFormDialogOpen: false,
	cycleReviewFormDialogOpen: false
});
export const useAdvantageCycleInfo = () => {
	const advantageCycleInfo = useContext(AdvantageCycleInfoContext);
	return advantageCycleInfo;
};

export default AdvantageCycleInfoContext.Provider;
